










import { defineComponent, SetupContext } from '@nuxtjs/composition-api';
import { useResult } from '@vue/apollo-composable/dist';
import { useFindValidCorporationQuery } from '~/graphql/graphqlOperations';
import useAppRoute from '~/compositions/useAppRoute';
import { useAppStore } from '~/store/app';

enum Tabs {
  Top,
  Feed,
  Job,
  Member,
}

export default defineComponent({
  layout: 'responsive',
  setup(_, context: SetupContext) {
    const corporaitonId = Number(context.root.$route.params.id);
    const { URLs, redirect } = useAppRoute();
    const { result, loading, error } = useFindValidCorporationQuery({
      id: corporaitonId,
    });
    const corporation = useResult(result);

    if (corporaitonId == 84812 || corporaitonId == 95683) {

      const { store } = useAppStore();
      const isSignIn = store.isSignedIn;

      if (!isSignIn) {
        redirect('/jobs')
      }
    }

    return {
      corporation,
      loading,
      error,
      URLs,
      Tabs,
    };
  },
});
